import { render, staticRenderFns } from "./CanvasCourseMappingForm.vue?vue&type=template&id=fb01f7be"
import script from "./CanvasCourseMappingForm.vue?vue&type=script&lang=ts"
export * from "./CanvasCourseMappingForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports